import { AsyncView } from '@aboutbits/react-toolbox'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import React from 'react'
import { useGetAddressById } from '../../address/db/addresses'
import {
  Section,
  SectionItem,
  SectionList,
  SectionTitle,
} from '../../../shared/section'
import { IconKeyboardArrowRight } from '../../../shared/svgs'
import { AddressTypeBadge } from '../../address/shared/AddressTypeBadge'

const ActivityAddressSection: React.FC<{ addressId: string }> = ({
  addressId,
}) => {
  const { data } = useGetAddressById(addressId)

  return (
    <AsyncView
      data={data}
      renderSuccess={(data) =>
        data && (
          <Section>
            <SectionTitle>
              <FormattedMessage
                id="activity.detail.address"
                defaultMessage="Related address"
              />
            </SectionTitle>
            <SectionList>
              <Link to={`/addresses/${data.id}`} className="block">
                <SectionItem>
                  <div className="flex-1">
                    <h2>{data.name}</h2>
                  </div>
                  <AddressTypeBadge typeId={data.addressTypeId} />
                  <div>
                    <IconKeyboardArrowRight className="size-6" />
                  </div>
                </SectionItem>
              </Link>
            </SectionList>
          </Section>
        )
      }
    />
  )
}

export { ActivityAddressSection }
